module.exports = __webpack_public_path__ + "static/media/dr-sampath.dd14c054.jpg";